// extracted by mini-css-extract-plugin
export var pillWrapper = "_nh-0";
export var showOverflow = "_nh-1";